<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" sm="12" md="4">
            <v-select
              :items="filteredRoles"
              v-model="role"
              label="Vai trò"
              item-value="id"
              item-text="description"
              return-object
              outlined
              dense
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="name"
              label="Tên người dùng"
              return-object
              clearable
              flat
              outlined
              dense
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <v-text-field
              v-model="code"
              clear-icon="mdi-close"
              label="Tài khoản"
              flat
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2" class="d-flex align-end">
        <v-btn class="search-button" @click="onFilterChanged" outlined>
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import get from 'lodash-es/get'
import { textHelpers } from '@/helpers/TextHelper'
import utils from '@/plugins/utils'
import mixins from './helper/mixins'

export default {
  components: {},
  data: () => ({
    name: '',
    query: '',
    statusList: ['active', 'block'],
    status: [],
    selectedRole: [],
    filterState: false,
    code: '',
    role: ''
  }),
  computed: {
    ...mapState('role', ['roles'])
  },
  methods: {
    ...mapActions('staff', ['updateStudent']),
    onFilterChanged() {
      const data = {
        code_contains: this.code,
        tags_contains: textHelpers.removeSpaces(utils.clearUnicode(this.name)),
        role: get(this.role, 'id')
      }

      this.$emit('onFilterChanged', data)
    }
  },
  mixins: [mixins]
}
</script>
